import React, { useState, useCallback } from 'react';
import { useParams, useLocation, useHistory } from 'react-router';

import WpButton, { Variant } from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import GiveRecognitionModal from 'Shared/components/modals/GiveRecognitionModal/GiveRecognitionModal';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

const DEFAULT_VARIANT = 'primary';

type Props = {
  variant?: Variant;
  className?: string;
};

function GiveKudosButton({ variant = DEFAULT_VARIANT }: Props) {
  const { feedbackRecognitionRequestId } = useParams();
  const { pathname } = useLocation();
  const history = useHistory();
  const { isGroup, isPersonal, id: workspaceUuid, name: workspaceName, users } = useWorkspace();
  const { id } = useCurrentUser();
  const teammate = users.find(u => u.id !== id);
  const [modalVisible, setModalVisible] = useState(false);

  const toggleModal = useCallback(() => {
    if (pathname.includes('recognition_request')) {
      history.push(`/workspaces/${workspaceUuid}`);
    }
    return setModalVisible(state => !state);
  }, [history, workspaceUuid, pathname]);

  const handleOpenModal = useCallback(() => {
    (window as any).analytics.track('Clicked Recognition Button', { button: 'Give Kudos', isGroupWorkspace: isGroup });
    return setModalVisible(true);
  }, [isGroup, teammate, workspaceName]);

  const emptyRecognitionRequest = {
    workspaceUuid,
    id: feedbackRecognitionRequestId,
    employee: teammate,
  };

  if (isPersonal) return null;

  return (
    <>
      {modalVisible && (
        <GiveRecognitionModal choosenRequest={emptyRecognitionRequest} isOpen onModalToggle={toggleModal} />
      )}
      <WpButton icon variant={variant} qaTest="give-kudos-button" onClick={handleOpenModal}>
        <WpIcon name="gem" />
        Give Kudos
      </WpButton>
    </>
  );
}

export default GiveKudosButton;
